import * as WorkOrderTypeActionType from './constants';

const defaultParams = {
  searchKey: '',
  skip: 1,
  take: 10,
  sort: { field: 'name', order: 'ascending' },
  status: 'all',
  totalRecord: 0,
  totalPage: 0
};

const ManageWorkOrderTypes = {
  items: [],
  params: defaultParams
};

const WorkOrderTypeProfile = {
  id: '',
  name: '',
  isActive: true
};

const WorkOrderTypeState = {
  ManageWorkOrderTypes: ManageWorkOrderTypes,
  WorkOrderTypeProfile: WorkOrderTypeProfile,
  ErrorMsg: [],
  IsOpenFormAddEdit: false,
  Title: 'Add work order type',
  IsCreate: true,
  dateTime: new Date(),
  WOTList: []
};

export default function WorkOrderTypesStore(
  state = WorkOrderTypeState,
  action
) {
  switch (action.type) {
    case WorkOrderTypeActionType.SEARCH_REQUEST_WORK_TYPE_SUCCESS:
      return processSearchSuccess(state, action);
    case WorkOrderTypeActionType.OPEN_FORM_CREATE_REQUEST_WORK_TYPE:
      return {
        ...state,
        WorkOrderTypeProfile: WorkOrderTypeProfile,
        Title: 'Add work order type',
        ErrorMsg: [],
        IsCreate: true,
        IsOpenFormAddEdit: true,
        dateTime: new Date()
      };
    case WorkOrderTypeActionType.CLOSE_FORM_CREATE_REQUEST_WORK_TYPE:
      return {
        ...state,
        IsOpenFormAddEdit: false
      };
    case WorkOrderTypeActionType.CREATE_REQUEST_WORK_TYPE_ASYNC:
    case WorkOrderTypeActionType.UPDATE_REQUEST_WORK_TYPE_ASYNC:
      return {
        ...state,
        ErrorMsg: []
      };
    case WorkOrderTypeActionType.GET_REQUEST_WORK_TYPE_BY_ID_SUCCESS:
      return processGetByIdSuccess(state, action);
    case WorkOrderTypeActionType.ADD_EDIT_REQUEST_WORK_TYPE_ERROR:
      return processAddEditError(state, action);
    case WorkOrderTypeActionType.RESET_REQUEST_WORK_TYPE:
      return {
        ...state,
        ManageWorkOrderTypes: {
          ...state.ManageWorkOrderTypes,
          params: defaultParams
        }
      };
    case WorkOrderTypeActionType.SELECT_LIST_WOT_SUCCESS:
      return processSelectWOTSuccess(state, action);
    default:
      return state;
  }
}

const processSearchSuccess = (state, action) => {
  var result = action.data;
  var mWOT = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      status: result.params.status,
      name: result.params.name,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    ManageWorkOrderTypes: mWOT,
    ErrorMsg: [],
    IsOpenFormAddEdit: false
  };
};

const processGetByIdSuccess = (state, action) => {
  return {
    ...state,
    WorkOrderTypeProfile: action.data,
    Title: 'Edit work order type',
    ErrorMsg: [],
    IsCreate: false,
    IsOpenFormAddEdit: true
  };
};

const processAddEditError = (state, action) => {
  return {
    ...state,
    ErrorMsg: [action.data.error],
    WorkOrderTypeProfile: {
      ...state.WorkOrderTypeProfile,
      name: action.data.params.name
    }
  };
};

const processSelectWOTSuccess = (state, action) => {
  return {
    ...state,
    WOTList: action.data
  };
};



// WEBPACK FOOTER //
// ./src/Work-Order-Type/reducers.js